import React from 'react';
import { Link } from 'react-router-dom';

const Intellectual = () => {
    return (
        <div className="page-container intellectual-page">
            <h1 className="page-title">Intellectual Well-being</h1>

            {/* Include the image */}
            <img
                src="/images/wf-intellectual.jpg" // Path to image in public folder
                alt="Person reading a book"
                className="page-image"
            />

            <p className="page-intro">
                Welcome to the Intellectual Well-Being section of Wholeness Forward. Intellectual well-being is an essential aspect of overall health, focusing on the pursuit of knowledge, creativity, and mental stimulation.
            </p>

            <p className="page-text">
                This dimension of well-being is not just about formal education; it’s about cultivating a love for lifelong learning, exploring new perspectives, and engaging in intellectually stimulating activities. By nurturing our intellectual well-being, we enhance our ability to think critically, solve problems, and make informed decisions.
            </p>

            <p className="page-text">
                Prioritizing intellectual well-being helps improve cognitive function, boosts creativity, and encourages a more informed and thoughtful approach to life. Whether through reading, problem-solving, or learning a new skill, an intellectually active mind can significantly enhance your quality of life.
            </p>

            <hr className="page-divider" />

            <h2 className="section-title">Subtopics to Explore</h2>
            <p className="section-description">Dive deeper into the aspects of intellectual well-being by exploring the following subtopics:</p>
            <ul className="content-list">
                <li><Link to="/intellectual/lifelonglearning" className="content-link">Lifelong Learning</Link></li>
                <li><Link to="/intellectual/reading" className="content-link">Reading and Literature</Link></li>
                <li><Link to="/intellectual/language" className="content-link">Learning Languages</Link></li>
                <li><Link to="/intellectual/braingames" className="content-link">Brain Games</Link></li>
                {/* <li>Educational Resources</li> */}
            </ul>

            <hr className="page-divider" />

            <h3 className="subheading">Community Intellectual Discussion</h3>
            <p className="page-text">
                Intellectual growth thrives when shared. Join our forum to exchange ideas, challenge your thinking, and connect with fellow learners. Whether you’re just starting or are a lifelong learner, your contributions help build a supportive and dynamic community.
            </p>
            <a href="/forum/Intellectual" className="btn">Join the Intellectual Discussion</a>
        </div>
    );
};

export default Intellectual;
